"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class LandingPage extends _react.default.Component {
  render() {
    const {
      user,
      isNonYAB
    } = this.props;

    if (!user) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: "/auth/login"
      });
    } // The user did not go to a specific /admin or /study URL, so let's take a look at their permissions and try to
    // redirect them to the best place possible.
    // If Admin redirect to /admin


    if (isAdmin(user)) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: "/admin"
      });
    }

    const authorizedStudies = getAuthorizedStudies(user); // If == 1 Study redirect to /study/id

    if (authorizedStudies && authorizedStudies.length === 1) {
      if (isNonYAB) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
          to: `/study/${authorizedStudies[0].studyId}`
        });
      }

      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: `/study/${authorizedStudies[0].studyId}/forums`
      });
    } // If > Study display landing page and let them pick


    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Welcome", user.firstName), authorizedStudies.map(study => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: study.studyId
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${study.studyId}`
      }, study.studyName));
    }));
  }

}

const isAdmin = user => {
  for (let i = 0; i < user.roles.length; i++) {
    if (user.roles[i].role.type === 'ADMIN') {
      return true;
    }
  }

  return false;
};

const getAuthorizedStudies = user => {
  const studyRoles = user.roles.filter(role => {
    return role.studyId != undefined;
  });
  const uniqueStudyRoles = (0, _uniqBy.default)(studyRoles, 'studyId').map(role => {
    return {
      studyId: role.studyId,
      studyName: role.studyName
    };
  });
  return uniqueStudyRoles;
};

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  user: selectors.getUser,
  isNonYAB: selectors.isNonYAB
});

var _default = (0, _reactRedux.connect)(mapStateToProps)(LandingPage);

exports.default = _default;